export default state => ({
  ...state,
  loadingDataOnPageLoad: null,
  initialisationFailure: false
});
